import React, { useEffect, useState, version } from 'react'
import styles from './Admin.module.css';
import Logo from '../../assets/updatelogo.svg'
import searchIcon from '../../assets/search-icon.png'
import rpDashboardIcon from '../../assets/rp-dashboard-icon.png'
import rpReportIcon from '../../assets/rp-report-icon.png'
import dashboardIcon from '../../assets/dashboard-icon.png'
import reportIcon from '../../assets/report-icon.png'
import settings from '../../assets/settings.png'
import blackLogout from '../../assets/black-logout.png'
import download from '../../assets/download-icon.png'
import filter from '../../assets/filter.png'
import refresh from '../../assets/refresh.png'
import upIcon from '../../assets/up-icon.png'
import rmIcon from '../../assets/rm-icon.png'
import planIcon from '../../assets/plan-icon.png'
// import { prpNonEncHttpAPI } from '../../services/prpNonEncHttpAPI';
import { prpHttpAPI } from '../../services/prpHttpAPI';
import { useNavigate } from 'react-router-dom';
import LineChart from '../../components/Chart/LineChart';
import channelData from '../../master/channel.json'
import regionData from '../../master/region.json'
import branchData from '../../master/branch.json'
import zoneData from '../../master/zone.json'

const Admin = () => {
  const navigate = useNavigate();
  const data = channelData.recordset;
  const uniqueChannels = new Set();
  const channelsData = [];

  for (const item of data) {
    if (item.CHANNEL && !uniqueChannels.has(item.CHANNEL)) {
      uniqueChannels.add(item.CHANNEL);
      channelsData.push(item);
    }
  }
  const regions = regionData.recordset
  const branches = branchData.recordset
  const zones = zoneData.recordset
  const [initialAdminData, setInitialAdminData] = useState([]);
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState([false]);
  const [totalPlans, setTotalPlans] = useState([])
  const [totalRM, setTotalRM] = useState(0);
  const [topCreators, setTopCreators] = useState([]);

  const checkUserLogin = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    if (!localtoken) {
      window.location.href = `${window.location.origin}/login`;
    }
  }

  useEffect(() => {
    checkUserLogin();

  }, [])

  const getLast15DaysStart = () => {
    const today = new Date();
    const last15DaysStart = new Date();
    last15DaysStart.setDate(today.getDate() - 14); // Start of the last 15 days
    return last15DaysStart.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getNextDate = (date) => {
    const today = new Date(date);

    today.setDate(today.getDate() + 1); // Add 1 day to the current date
    console.log("next date", today);
    return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  const getCurrentDate = () => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0'); // Ensures two-digit day
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensures two-digit month (Months are 0-based)
    const year = currentDate.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    console.log(formattedDate);
    return formattedDate;
  }
  const sortByCreatedAtAsc = (data) => {
    return data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  };
  const [fromDate, setFromDate] = useState(getLast15DaysStart())
  const [toDate, setToDate] = useState(getNextDate(new Date()));

  const userData = {
    fromdate: fromDate,
    todate: getNextDate(toDate)
  };
  // const userData={
  //   fromdate:"2025-03-01",
  //   todate: "2025-03-20"
  // }
  const getData = async () => {
    console.log("user", userData);
    const localtoken = localStorage.getItem("ssotoken");
    let result;

    if (localStorage.getItem('isAdmin') == 1) {
      console.log("admin called");
      setLoading(true);
      result = await prpHttpAPI(userData, 'admin', localtoken, "POST");
      if (!result.success) {
        console.log("non-admin called");
        result = await prpHttpAPI(userData, 'user-dashboard', localtoken, "POST");
        setLoading(false);
      }
      else {
        setLoading(false);
      }

    } else {
      console.log("non-admin called");
      setLoading(true);
      result = await prpHttpAPI(userData, 'user-dashboard', localtoken, "POST");
      setLoading(false);
    }

    if (result.success) {
      console.log("admin data is:-----------", result);
      const sortedData = result?.data?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      setInitialAdminData(sortedData);
      setFilteredData(sortedData);  // Set both original and filtered data
    } else {
      console.log("result in error", result);
      setInitialAdminData([]);
      setFilteredData([]);
    }
  };

  const getTotalPlans = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    let result;
    const data = {
      fromdate: "2025-02-10",
      todate: getNextDate(toDate),
    };
    // if (localStorage.getItem('isAdmin') == 0) {
    setLoading(true);
    result = await prpHttpAPI(data, 'user-dashboard', localtoken, "POST");
    setLoading(false);
    // }else{
    //   result = null;
    // }

    if (result?.success) {
      console.log("total plan count:", result);
      // const ascPlans = sortByCreatedAtAsc(result.data)
      setTotalPlans(result?.data);  // ✅ Set the totalPlans properly
    } else {
      console.log("error or admin-totalplans", result);
    }
  };

  const getTotalRMs = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    const data = {
      fromdate: "2025-02-10",
      todate: getNextDate(toDate),
      flagType: "count"
    };

    let result;
    // if (localStorage.getItem('isAdmin') == 0) {
    setLoading(true);
    result = await prpHttpAPI(data, 'user-dashboard', localtoken, "POST");
    setLoading(false);
    // } else {
    // result = null;
    // }

    if (result?.success) {
      console.log("total rm:", result);
      setTotalRM(result.data[0].total_count);
    } else {
      console.log("Error or admin-call", result);
    }
  };

  // ✅ Proper async handling with awaiting totalPlans
  const topPlanCreators = async () => {
    // await getTotalPlans(); // Ensure the totalPlans are fetched first
    console.log("total plans are::", totalPlans);

    // 1️⃣ Group data by rm_code
    const rmStats = totalPlans.reduce((acc, item) => {
      const { rm_code, EMP_NAME, rmcode, rmname, created_at } = item;
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[new Date(created_at).getMonth()];


      if (!acc[rm_code || rmcode]) {
        acc[rm_code || rmcode] = {
          name: EMP_NAME || rmname,
          total_plans: 0,
          plans_by_month: {}
        };
      }

      acc[rm_code || rmcode].total_plans++;

      if (!acc[rm_code || rmcode].plans_by_month[month]) {
        acc[rm_code || rmcode].plans_by_month[month] = 0;
      }

      acc[rm_code || rmcode].plans_by_month[month]++;

      return acc;
    }, {});
    console.log("rmstats", rmStats);

    // 2️⃣ Convert the object into an array and sort by total_plans in descending order
    const result = Object.entries(rmStats)
      .map(([rm_code, details]) => ({
        rm_code,
        name: details.name,
        total_plans: details.total_plans,
        plans_by_month: details.plans_by_month
      }))
      .sort((a, b) => b.total_plans - a.total_plans);

    console.log("Final Sorted Data:", result);

    const topThree = result.slice(0, 3);
    console.log("Top 3 Creators:", topThree);
    return topThree;
  };
  /////////////
  useEffect(() => {
    getTotalRMs();
    getTotalPlans();

  }, [])
  useEffect(() => {
    // Use async IIFE to await async functions
    (async () => {
      const data = await topPlanCreators();
      console.log("Top Creators:", data);
      setTopCreators(data);  // ✅ Set top creators properly
    })();
  }, [totalPlans])
  useEffect(() => {
   // getData();
  }, [fromDate, toDate])

  // search for versions 
  const handleVersionSearch = async (plan_id) => {

    try {
      let data = { plan_id: plan_id };
      console.log("data", data);

      const localtoken = localStorage.getItem("ssotoken");

      const result = await prpHttpAPI(data, "search-plan", localtoken, "POST");

      if (result.success) {
        console.log("result in search", result);
        console.log("plan id is ", result.data.lastCompletedPlan.planDetails.plan_id);
        //   let versions = null;
        //   let str = result.data.lastCompletedPlan.planDetails.plan_id;
        //   if (str.includes('_')) {
        //     // Split the string by underscore and convert the part after it to a number
        //     const parts = str.split('_');
        //     versions = parseInt(parts[1], 10);
        // } else {
        //     // If no underscore, return 1
        //     versions = 1;
        // }
        // console.log('version is', versions);
        //   console.log('----------------', plan_id, versions)
        handleEyeClick(plan_id, result.data.version.versions)
      } else {
        console.log("result error in view click");
        return;
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleEyeClick = (plan_id, versions) => {
    let planID = "";
    let editableID = '';
    if (versions > 1) {
      planID = `${plan_id}_${versions}`
      editableID = `${plan_id}_${versions}`;
    } else if (versions == 1) {
      planID = plan_id;
      editableID = `${plan_id}_${versions}`;
    } else {
      return;
    }
    localStorage.setItem("plan_id", planID);
    localStorage.setItem("versions", versions)
    localStorage.setItem('editableID', editableID);
    localStorage.setItem('planCompletedFlag', JSON.stringify(true));


    // navigate('/plan-output',  { state: { from: "search" } });
    const newRoute = '/plan-output';   // Target route
    const fullPath = window.location.origin + newRoute;
    window.open(fullPath, '_blank');   // Open in new tab
  }

  const [filters, setFilters] = useState({
    channel: "",
    region: "",
    zone: "",
    branch: "",
  });
  const [activeItem, setActiveItem] = useState('report');

  const formatDate = (isoString) => {
    const [year, month, day] = isoString?.split("T")[0].split("-"); // Extracts date and splits it
    return `${day}-${month}-${year}`; // Rearranges to DD-MM-YYYY
  };
  const getRetirementYear = (currentYear, currentAge, retirementAge) => {
    const yearsLeft = retirementAge - currentAge; // Calculate remaining years
    return currentYear + yearsLeft; // Add remaining years to the current year
  };
  const capitalizeName = (name) => {
    if (name) {
      return name
        .trim() // remove extra spaces from start and end
        .split(' ') // split into words
        .filter(Boolean) // remove any empty strings caused by multiple spaces
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // capitalize first letter
        .join(' '); // join words back
    }
    else {
      return "";
    }

  }

  // ✅ Apply in-memory filtering
  const applyFilters = () => {
    const filtered = initialAdminData.filter((item) => {
      const matchesChannel = !filters.channel || item.CHANNEL === filters.channel;
      const matchesRegion = !filters.region || item.REGION_NAME === filters.region;
      const matchesZone = !filters.zone || item.ZONE_NAME === filters.zone;
      const matchesBranch = !filters.branch || item.BRANCH_NAME === filters.branch;

      return matchesChannel && matchesRegion && matchesZone && matchesBranch;
    });

    console.log("Filtered data:", filtered);
    setFilteredData(filtered);  // Update the displayed data
  };

  // ✅ Handle filter change and apply filtering
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // ✅ Trigger filtering whenever filters change
  useEffect(() => {
    applyFilters();
  }, [filters, initialAdminData]);

  // const filteredData = initialAdminData?.filter((item) => {
  //   const itemDate = new Date(item.created_at);
  //   const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
  //   const toDate = filters.toDate ? new Date(filters.toDate) : null;

  //   return (
  //     (!filters.fromDate || itemDate >= fromDate) &&
  //     (!filters.toDate || itemDate <= toDate) &&
  //     (!filters.channel || item.channel === filters.channel) &&
  //     (!filters.region || item.region === filters.region) &&
  //     (!filters.zone || item.zone === filters.zone) &&
  //     (!filters.branch || item.branch === filters.branch)
  //   );
  // });

  const downloadUserCSV = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME, item.BRANCH_NAME,

      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '', capitalizeName(item.client_name), item.plan_id, getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement), formatDate(item.created_at), formatDate(item.updated_at),

      capitalizeName(item.EMP_NAME),
      item.rm_code]);


      let csvContent = "data:text/csv;charset=utf-8,"
        + [headers, ...rows].map(e => e.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `prp-report-${getCurrentDate()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("Admin data is of length 0.");
    }


  };
  const downloadAdminCSV = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "PLAN STATUS", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME,
      item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '',
      capitalizeName(item.client_name), item.plan_id, item.plan_completed == 1 ? "Plan Created" : "Pending",
      getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement),
      formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.rmname),
      item.rmcode ? item.rmcode : '']);

      let csvContent = "data:text/csv;charset=utf-8,"
        + [headers, ...rows].map(e => e.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `prp-report-${getCurrentDate()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("Admin data is of length 0.");
    }

  };
  const handleLogout = () => {
    // Clear session storage (or localStorage if you want)
    localStorage.clear();
    // If you're using localStorage, you can do the same
    // localStorage.clear();

    // Optionally, remove specific keys instead of clearing everything
    //localStorage.removeItem('yourKey');
    // localStorage.removeItem('yourKey');

    // Redirect to the login page
    window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;
    navigate('/?action=logout'); // Adjust the path to your login page
  };

  const handleSearchSubmit = () => {
  // Simply triggers your existing data fetch function manually
  getData();
};
  return (
    <div className={styles.main}>
      <div className={styles.bottomContent}>
        <div className={styles.leftHead}>
          <div className={styles.navList}>
            <ul>
              <li onClick={() => setActiveItem('dashboard')} className={activeItem == 'dashboard' ? styles.active : ""}><span><img src={activeItem == 'dashboard' ? dashboardIcon : rpDashboardIcon} alt="dashboard-icon" /></span><span>Dashboard</span></li>
              <li onClick={() => setActiveItem('report')} className={activeItem == 'report' ? styles.active : ""}><span><img src={activeItem == 'report' ? rpReportIcon : reportIcon} alt="report-icon" /></span><span>Report</span></li>
            </ul>
          </div>
          <div className={styles.footList}>
            <div><span><img src={settings} alt="settings" /></span><span>Settings</span></div>
            <div onClick={handleLogout} ><span><img src={blackLogout} alt="logout" /></span><span>Logout</span></div>
          </div>
        </div>
        {activeItem == 'dashboard' ?
          <div className={styles.rightContent}>
            <h2>Dashboard</h2>
            <div className={styles.cardDiv}>
              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Total RMs</span>
                    <span>  {loading ?
                      <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                        <span className="sr-only"></span>
                      </div> : totalRM}</span>
                  </span>
                  <span className={styles.topImg}><img src={rmIcon} alt="rm-icon" /></span>
                </div>
                {/* <div className={styles.cardBottom}><span> <img src={upIcon} alt="up-icon" /> <span className={styles.upTest}> 8.5%</span> Up from yesterday</span></div> */}
              </div>
              {/*  */}
              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Plan Created</span>
                    <span> {loading ?
                      <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                        <span className="sr-only"></span>
                      </div> : totalPlans.length}</span>
                  </span>
                  <span className={styles.topImg}><img src={planIcon} alt="plan-icon" /></span>
                </div>
                {/* <div className={styles.cardBottom}><span><img src={upIcon} alt="up-icon" /> <span className={styles.upTest}> 1.3%</span> Up from past week</span></div> */}
              </div>
            </div>
            <h3>Top Plan Creator</h3>
            <div className={styles.chartDiv}>
              <div className={styles.chartContainer}>

                {topCreators?.length > 0 ? (
                  topCreators.map((item, index) => (
                    <div className={styles.chart}>
                      <LineChart className={styles.lineChart} key={item.rm_code} data={item} index={index} />
                    </div>
                  ))
                ) : (
                  <p>No data available</p>
                )}

                {/* <ul>
            <li>Regional</li>
           </ul> */}
              </div>
            </div>

          </div>
          :
          <div className={styles.rightContent}>
            <h2>Report</h2>
            <div className={styles.downloadDiv}>


              {/* Filters */}
              <div className={styles.filters}>
                <div className={styles.filterDiv}>
                  {/* <div><span><img src={filter} alt="filterIcon" /></span><span className='ms-2'>Filter By</span></div> */}
                  <button>Filter By</button>
                </div>
                <div className={styles.filterDiv}>
                  <input type="date" name="fromDate" value={filters.fromDate || ""} min="2025-02-10" max={toDate > (new Date().toISOString().split('T')[0]) ? (new Date().toISOString().split('T')[0]) : toDate} onChange={(e) => {
                    setFromDate(e.target.value);
                    handleFilterChange(e);
                  }} />
                </div>
                <div className={styles.filterDiv}>
                  <input type="date" name="toDate" value={filters.toDate || ""} min={fromDate} max={new Date().toISOString().split('T')[0]} onChange={(e) => {
                    setToDate(e.target.value);
                    handleFilterChange(e);
                  }} />
                </div>
                <div className={styles.filterDiv}>
                  <select name="channel" value={filters.channel} onChange={handleFilterChange}>
                    <option value="">Channel</option>
                    {channelsData.map((channel) => (
                      <option key={channel.CHANNEL} value={channel.CHANNEL}>
                        {channel.CHANNEL}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterDiv}>
                  <select name="region" value={filters.region} onChange={handleFilterChange}>
                    <option value="">Region</option>
                    {regions.map((region) => (
                      <option key={region.REGION_NAME} value={region.REGION_NAME}>
                        {region.REGION_NAME}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.filterDiv}>
                  <select name="zone" value={filters.zone} onChange={handleFilterChange}>
                    <option value="">Zone</option>
                    {zones.map((zone) => (
                      <option key={zone.ZONE_NAME} value={zone.ZONE_NAME}>
                        {zone.ZONE_NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterDiv}>
                  <select name="branch" value={filters.branch} onChange={handleFilterChange}>
                    <option value="">Branch</option>
                    {branches.map((branch) => (
                      <option key={branch.BRANCH_NAME} value={branch.BRANCH_NAME}>
                        {branch.BRANCH_NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterDiv}>
    <button 
      onClick={handleSearchSubmit}
    >
      Search
    </button>
  </div>
                <div className={styles.filterDiv}>
                  <button onClick={() => {
                    setFilters({ channel: "", region: "", zone: "", branch: "" });
                    setFromDate(getLast15DaysStart());
                    setToDate(getNextDate(new Date));
                  }}>
                    {/* <span><img src={refresh} alt="refreshIcon" /></span> */}
                    Reset
                  </button>
                </div>

              </div>



              <div className={styles.downloadTab}>
                <div onClick={localStorage.getItem('isAdmin') == 1 ? downloadAdminCSV : downloadUserCSV}>
                  <span><img src={download} alt="download-icon" /></span><span>Download as</span>
                </div>
                <div>
                  <button disabled>PDF</button>
                  <button disabled>Excel</button>
                  <button disabled>Word</button>
                </div>
              </div>
            </div>
            <div className={styles.tableDiv}>
              {loading &&
                <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                  <span className="sr-only"></span>
                </div>}
              {<table>
                <thead>
                  <tr>
                    <th>Channel</th>
                    <th>Region</th>
                    <th>Zone</th>
                    <th>Branch</th>
                    <th>RM Name</th>
                    <th>Business Code</th>
                    <th>Investor</th>
                    <th>RP Plan ID</th>
                    {localStorage.getItem('isAdmin') == 1 && <th>Plan Status</th>}
                    <th>Year of Retirement</th>
                    <th>Plan Creation Date</th>
                    <th>Plan Revision Date</th>
                    <th>Plan Created By</th>
                    <th>Spoc RM Code</th>
                    <th>View Plan</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.CHANNEL}</td>
                        <td>{item.REGION_NAME}</td>
                        <td>{item.ZONE_NAME}</td>
                        <td>{item.BRANCH_NAME}</td>
                        <td>{item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : capitalizeName(item.rmname || item.EMP_NAME)}</td>
                        <td>{item.spoc_rm ? item.spoc_rm : (item.rmcode || item.rm_code)}</td>
                        <td>{capitalizeName(item.client_name)}</td>
                        <td>{item.plan_id}</td>
                        {localStorage.getItem('isAdmin') == 1 && <td>{item.plan_completed == 1 ? "Plan Created" : "Pending "}</td>}
                        <td>{getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement)}</td>
                        <td>{formatDate(item.created_at)}</td>
                        <td>{formatDate(item.updated_at)}</td>
                        {/* PLAN cREATED BY */}
                        <td>{capitalizeName(item.rmname || item.EMP_NAME)}</td>
                        <td>{(item.rmcode || item.rm_code)}</td>
                        <td> <span className={styles.viewText} onClick={() => handleVersionSearch(item.plan_id)}>view</span></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="15">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>}
            </div>
          </div>
        }

      </div>
    </div>
  )
}

export default Admin